import React from 'react';

const EmptyMessage = () => (
  <div className="container__loader">
    <h4>
      you do not have any message
    </h4>
    <h4>
      Try one
    </h4>
  </div>
);

export default EmptyMessage;
